import { Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { useMediaKit } from "@/lib/mediaKit";
import { topics } from "@/pages/SpeakingPage";

const OneSheet = () => {
  const kit = useMediaKit();
  if (!kit) return null;
  if (kit.one_sheet_url) { window.location.replace(kit.one_sheet_url); return null; }
  const photo = kit.gallery.find((g) => g.kind === "stage")?.url || kit.headshots[0]?.url;

  return (
    <div className="min-h-screen bg-[#e9e7f2] py-10 print:p-0 print:bg-white" data-testid="one-sheet-page">
      <style>{"@page { size: letter; margin: 0 } @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact } }"}</style>
      <div className="max-w-[8.5in] mx-auto mb-6 flex justify-between print:hidden">
        <Link to="/media" className="inline-flex items-center gap-2 text-sm text-[#3b2a6b]" data-testid="one-sheet-back"><ArrowLeft className="w-4 h-4" /> Media Kit</Link>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-[#7c3aed] text-white px-5 py-2 rounded-full text-sm font-semibold" data-testid="one-sheet-print-btn"><Printer className="w-4 h-4" /> Save as PDF / Print</button>
      </div>
      <article className="w-[8.5in] min-h-[11in] mx-auto bg-[#070710] text-[#f0f0f5] shadow-2xl print:shadow-none overflow-hidden">
        {photo && (
          <div className="relative aspect-video">
            <img src={photo} alt="Raulvin Coke" className="w-full h-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#070710] via-[#070710]/30 to-transparent" />
            <div className="absolute bottom-6 left-10">
              <p className="text-[10px] uppercase tracking-[0.35em] text-[#a78bfa] font-semibold">The People's Futurist</p>
              <h1 className="font-display text-5xl font-bold">Raulvin Coke</h1>
              <p className="font-display italic text-[#a78bfa] text-lg">AI, Adaptive Intelligence &amp; the Future of Human Decision-Making</p>
            </div>
          </div>
        )}
        <div className="px-10 py-8 grid grid-cols-[1.3fr_1fr] gap-8">
          <div>
            <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#a78bfa] font-semibold mb-3">About</h2>
            <p className="text-[12px] leading-relaxed text-[#c9c9d6]">{kit.bios.medium || kit.bios.short}</p>
            <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#a78bfa] font-semibold mt-6 mb-3">Formats</h2>
            <p className="text-[12px] text-[#c9c9d6]">Keynotes · Executive briefings · Panels &amp; moderated conversations · Workshops</p>
          </div>
          <div>
            <h2 className="text-[10px] uppercase tracking-[0.3em] text-[#a78bfa] font-semibold mb-3">Signature Topics</h2>
            <ul className="space-y-2.5">
              {topics.map((t) => (
                <li key={t.title}>
                  <p className="font-display text-[15px] font-semibold leading-tight">{t.title}</p>
                  <p className="text-[11px] text-[#9ca3b8]">{t.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mx-10 border-t border-[#7c3aed]/30 py-5 flex justify-between text-[11px] text-[#9ca3b8]">
          <span>Founder &amp; CEO, Agentic FuturePath AI · Educator of the Future Award, AI NEXTGEN America</span>
          <span className="text-white">raulvincoke.com/speaking</span>
        </div>
      </article>
    </div>
  );
};

export default OneSheet;
